import { getBackendUrl } from "../config";

function apiUrl(path) {
  const backendUrl = getBackendUrl();
  if (!backendUrl) return "";
  return `${backendUrl}${path}`;
}

export async function fetchPublishedRoutes() {
  const url = apiUrl("/api/routes");
  if (!url) return [];
  const response = await fetch(url, { cache: "no-store" });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new Error(data.error || "טעינת הנתיבים נכשלה");
  }
  return Array.isArray(data.items) ? data.items : [];
}
